import React from 'react';
import LikeButton from '../LikeButton';
import OverflowMenu from '../utils/OverflowMenu';
import styles from './SongPage.module.scss';
import GenreTag from '../GenreTag/GenreTag';
import EmojiArray from '../EmojiArray/EmojiArray';
import EmojiPicker from '../EmojiPicker/EmojiPicker';
import OpenGraphCard from '../OpenGraphCard';
import TranslateControl from '../TranslateControl/TranslateControl';
import { getPlainTextFromRichHtml, isTextOnlyUrls } from '../../utils/openGraphUtils';

const DescriptionSection = ({
  songDetails,
  likesAmount,
  commentCount,
  isLiked,
  handleLike,
  handleUnlike,
  isLiking,
  isCurrentUser,
  menuOptions1,
  menuOptions2,
  setShowLikers,
  scrollToCommentSection,
  renderDescriptionWithLinks,
  onDescriptionMentionClick,
  handleEmojiSelect,
  emojiReactions,
  currentUserEmoji,
  openGraphData,
  openGraphLoading,
}) => {
  const hasMetadata = likesAmount > 0 || commentCount > 0;
  const descriptionPlain = getPlainTextFromRichHtml(songDetails.description || '');
  const showAboutSong =
    songDetails.description &&
    descriptionPlain.length > 0 &&
    !isTextOnlyUrls(descriptionPlain);

  return (
    <div className={styles.descriptionSection}>
      {showAboutSong && (
        <div className={styles.descriptionBox}>
          <span className={styles.descriptionBoxLabel}>About this song:</span>
          <TranslateControl
            songId={songDetails.id}
            description={songDetails.description}
            mentionedHandles={songDetails.mentionedHandles}
            textClassName={styles.description}
            renderDescriptionWithLinks={renderDescriptionWithLinks}
            onMentionClick={onDescriptionMentionClick}
          />
        </div>
      )}

      {/* OpenGraph Link Cards */}
      {openGraphData?.length > 0 && (
        <div className={styles.openGraphContainer}>
          {openGraphData.map((ogData, index) => (
            <OpenGraphCard
              key={`${ogData.url}-${index}`}
              data={ogData}
              compact={false}
              className={styles.openGraphCard}
            />
          ))}
        </div>
      )}
      {songDetails.genres && songDetails.genres.length > 0 && (
        <div className={styles.genreTags}>
          {songDetails.genres.map((genre, index) => (
            <GenreTag key={index} genre={genre} />
          ))}
        </div>
      )}
      {hasMetadata && (
        <div className={styles.metadata}>
          {likesAmount > 0 && (
            <button
              onClick={() => setShowLikers(true)}
              className={styles.metaCount}
            >
              {likesAmount} {likesAmount === 1 ? 'like' : 'likes'}
            </button>
          )}
          {commentCount > 0 && (
            <button
              onClick={scrollToCommentSection}
              className={styles.metaCount}
            >
              {commentCount} {commentCount === 1 ? 'comment' : 'comments'}
            </button>
          )}
        </div>
      )}
      <div className={styles.utilButtons}>
        <EmojiPicker
          onEmojiSelect={handleEmojiSelect}
          currentEmoji={currentUserEmoji}
        />
        <div className={styles.utilButtonsRight}>
          <EmojiArray
            songId={songDetails.id}
            emojiReactions={emojiReactions}
            reactionUsers={songDetails.reactionUsers}
          />
          <LikeButton
            isLiked={isLiked}
            onLike={handleLike}
            onUnlike={handleUnlike}
            likeCount={likesAmount}
            disabled={isLiking}
          />
          {isCurrentUser ? (
            <OverflowMenu options={menuOptions2} />
          ) : (
            <OverflowMenu options={menuOptions1} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DescriptionSection;
